/**
 * Setup Error Types
 *
 * Shared error classes thrown by `performSetup` functions (e.g. performAppleMerchantSetup)
 * and caught by `useSetupAction` to manage loading/error UI state.
 */

/** Thrown when the user cancels a setup flow (e.g. dismisses Apple Pay sheet). Not displayed as an error. */
export class SetupCancelledError extends Error {
  constructor() {
    super('cancelled');
    this.name = 'SetupCancelledError';
  }
}
